import {
  customElement,
  FASTElement,
  Observable,
  observable,
  Splice,
} from '@microsoft/fast-element';
import { VppaDetailModalTemplate as template } from './vppa-detail-modal.template';
import { VppaDetailModalStyles as styles } from './vppa-detail-modal.styles';
import { IVppa } from '../../../types';
import { IVppaService } from '../../../services';
import { IEnumService } from '../../../services/enum.service';

const name = 'vppa-detail-modal';

@customElement({
  name,
  template,
  styles,
})
export class VppaDetailModal extends FASTElement {
  @IVppaService vppaService: IVppaService;
  @IEnumService enumService: IEnumService;
  @observable show: boolean = false;
  @observable width: string = '390px';
  @observable title = 'Contract Details';
  @observable data: IVppa = {} as IVppa;

  private notifier: any;
  private handler: any;
  private idHandler: any;

  connectedCallback() {
    super.connectedCallback();
    this.showModalListener();
  }

  private showModalListener() {
    const _this = this;
    this.notifier = Observable.getNotifier(this.vppaService);
    this.handler = {
      handleChange(source: any, splices: Splice[]) {
        _this.show = source.vppaDetailModalVisibility;
      },
    };
    this.idHandler = {
      handleChange(source: any, splices: Splice[]) {
        const id = source.vppaDetailModalVppaId;
        if (id) {
          _this.getVppaData(id);
        }
      },
    };
    this.notifier.subscribe(this.handler, 'vppaDetailModalVisibility');
    this.notifier.subscribe(this.idHandler, 'vppaDetailModalVppaId');
  }

  private getVppaData(vppaId: string) {
    this.vppaService.getVppa(vppaId).then((data) => {
      this.data = { ...data.REPLY[0] };
    });
  }

  public closeModal() {
    this.data = {} as IVppa;
    this.vppaService.closeVppaDetailModal();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.vppaService.closeVppaDetailModal();
  }
}
